import React, { useMemo } from 'react';
import * as THREE from 'three';
import { useObstacles } from '../../hooks/useObstacles';
import { ObstacleSign } from './ObstacleSign';
import { findNearestPoint } from '../../utils';

interface ObstaclesProps {
  teePos: THREE.Vector3;
  greenPos: THREE.Vector3;
}

export const Obstacles: React.FC<ObstaclesProps> = ({ teePos, greenPos }) => {
  const obstacles = useObstacles();

  const obstacleSigns = useMemo(() => {
    return obstacles.reduce((acc, { id, mesh }) => {
      const nearestPointsToTee = findNearestPoint(mesh, teePos);
      const nearestPointsToGreen = findNearestPoint(mesh, greenPos);

      return [
        ...acc,
        nearestPointsToTee.success && (
          <ObstacleSign
            key={`${id}_tee`}
            greenPos={greenPos}
            teePos={teePos}
            position={nearestPointsToTee.point}
          />
        ),
        nearestPointsToGreen.success && greenPos.distanceTo(nearestPointsToGreen.point) > 50 && (
          <ObstacleSign
            key={`${id}_green`}
            greenPos={greenPos}
            teePos={teePos}
            position={nearestPointsToGreen.point}
          />
        ),
      ];
    }, [] as React.ReactNode[]);
  }, [obstacles, teePos, greenPos]);

  return <>{obstacleSigns}</>;
};

export default Obstacles;
